import './App.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './components/Login';
import RequireAuth from './components/RequireAuth';
import Unauthorized from './components/Unauthorized';
import Home from './components/Home';
import Missing from  './components/Missing';

import {theme, Notifications} from '@dronebase/shared-ui-core';
import {MantineProvider} from '@mantine/core';

function App() {

  return (
    <MantineProvider theme={theme} withGlobalCss>
      <Notifications />
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* public routes */}
            <Route path="login" element={<Login />} />
            <Route path="unauthorized" element={<Unauthorized />} />

            {/* we want to protect these routes */}
            <Route element={<RequireAuth />}>
              <Route path="/" element={<Home />} />
            </Route>
            {/* catch all */}
            <Route path="*" element={<Missing />} />
          </Route>
        </Routes>
    </MantineProvider>
  );
}

export default App;